import { Routes } from '@angular/router';

const title = 'Publicaciones';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [

  {
    path: 'cita',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Parejas' }] },
        loadComponent: () => import('./pages/pareja-lista/pareja-lista.component'),
      },
    
    ],
  },
];
